import { iResponseApuracao } from "../dto/dados-apuracao.dto";
import styles from "../styles/apuracao.module.css";

export default function ApuracaoBancoHoras({ apuracaoState }: iProps) {
    if (Object.values(apuracaoState.banco_horas).length === 0) {
        return <div></div>;
    }
    if (apuracaoState.banco_horas.atual_bc_ativo === false) { 
        return <div></div>;
    }

    const tPassado = apuracaoState.banco_horas.anterior;
    let bg_saldo_passado = BG_PADRAO
    if (tPassado.horas_saldo > 10) {
        bg_saldo_passado = BG_ATENCAO
    } else if (tPassado.horas_saldo < 0) {
        bg_saldo_passado = BG_NEGATIVO
    }
    
    const tAtual = apuracaoState.banco_horas.atual;
    let bg_saldo_atual = BG_PADRAO
    if (tAtual.horas_saldo > 10) {
        bg_saldo_atual = BG_ATENCAO
    } else if (tAtual.horas_saldo < 0) {
        bg_saldo_atual = BG_NEGATIVO
    }
    
    const total = apuracaoState.banco_horas.total;
    let bg_saldo_total = BG_PADRAO
    if (total.horas_saldo > 10) {
        bg_saldo_total = BG_ATENCAO
    } else if (total.horas_saldo < 0) {
        bg_saldo_total = BG_NEGATIVO
    }

    return (
        <div>
            <br></br>
            <p>BANCO DE HORAS</p>
            <br></br>
            
            <div className="div-row">
                <div className={styles.totaisContainer} style={{backgroundColor: bg_saldo_passado}}>
                    <p>{tPassado.HS}</p>
                    <p>Saldo ACUMULADO</p>
                </div>
                
                <div className={styles.totaisContainer} style={{backgroundColor: bg_saldo_atual}}>
                    <p>{tAtual.HS}</p>
                    <p>Saldo ATUAL</p>
                </div>
                
                <div className={styles.totaisContainer} style={{backgroundColor: bg_saldo_total}}>
                    <p>{total.HS}</p>
                    <p>Saldo TOTAL</p>
                </div>
                
                <div className={styles.totaisContainer} style={{opacity: 0}}>
                </div>
                <div className={styles.totaisContainer} style={{opacity: 0}}>
                </div>
                <div className={styles.totaisContainer} style={{opacity: 0}}>
                </div>
                <div className={styles.totaisContainer} style={{opacity: 0}}>
                </div>
            </div>
        </div>
    );
    
    
}
interface iProps {
    apuracaoState: iResponseApuracao;
}

const BG_PADRAO = "rgb(241, 241, 241)"
// const BG_POSITIVO = "rgba(184, 228, 167, 1)"
const BG_ATENCAO = "#FFFDBF"
const BG_NEGATIVO = "rgb(254, 197, 187)"
